import { ElementRef, OnDestroy, OnInit, ChangeDetectorRef, Injectable } from '@angular/core';
import { catchError, exhaustMap, of, Subject, takeUntil } from 'rxjs';
import { IVisibilityService } from '../visibility.service';
import { IIntervalService } from '../interval.service';

@Injectable()
export abstract class BaseComponent implements OnInit, OnDestroy {
  private $destroyed = new Subject<void>();

  protected get destroyed$() {
    return this.$destroyed;
  }

  /* Override in derived classes to specify interval in seconds */
  protected get $intervalSeconds(): number {
    return undefined; // No interval by default
  }

  constructor(
    protected elementRef: ElementRef,
    protected cdr: ChangeDetectorRef,
    protected visibilityService: IVisibilityService,
    protected intervalService: IIntervalService) {
  }

  /* Angular OnInit lifecycle method - calls derived class $onInit */
  ngOnInit(): void {
    this.$onInit();
    this.setupVisibilityIntervalSubscription();
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
    this.$onDestroy();
  }

  protected $onInit(): void {
    // Override in derived classes if needed
  }

  protected $onDestroy(): void {
    // Override in derived classes if needed
  }

  protected $onInterval(): Promise<void> {
    // Override in derived classes if needed
    return Promise.resolve();
  }

  /* override this method to handle cases when component contents were reappear. Initially overriden only for grid.component.hbs */
  protected $initEmpty() { }

  private setupVisibilityIntervalSubscription() {
    const visible = this.visibilityService.effectiveVisibilityChange(this.elementRef.nativeElement);

    this.intervalService.startInterval(visible, this.$intervalSeconds * 1000)
      .pipe(
        takeUntil(this.$destroyed),
        exhaustMap(async () => {
          await this.$onInterval();
          this.cdr.detectChanges();
        }),
        catchError(err => {
          console.error(err);
          return of(null)
        })
      )
      .subscribe();
  }
}